import { Suspense, lazy } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import PageTransition from "./components/feature/PageTransition";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then((m) => ({
        default: m.ReactQueryDevtools,
      }))
    )
  : () => null;
import { InstallBanner } from './components/pwa/InstallBanner';
import { CookieConsentProvider } from './components/cookies/CookieConsentProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      // Voltar para a aba não refaz as consultas: a psicóloga perdia a tela
      // "recarregando" no meio do trabalho. Dados atualizam ao navegar
      // (staleTime) e nas mutations.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <CookieConsentProvider>
              <PageTransition>
                <AppRoutes />
              </PageTransition>
            </CookieConsentProvider>
          </BrowserRouter>
        </ThemeProvider>
      </I18nextProvider>
      </AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'text-sm font-medium text-neutral-800 rounded-xl shadow-card border border-neutral-100',
          success: { iconTheme: { primary: '#2D4A3E', secondary: '#F8F9FA' } }
        }}
      />
      {import.meta.env.DEV && (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
        </Suspense>
      )}
      <InstallBanner />
    </QueryClientProvider>
  );
}

export default App;
